import { render, staticRenderFns } from "./TSZ_Registro_Usuarios.vue?vue&type=template&id=6f84c4e5&scoped=true&"
import script from "./TSZ_Registro_Usuarios.vue?vue&type=script&lang=js&"
export * from "./TSZ_Registro_Usuarios.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Registro_Usuarios.vue?vue&type=style&index=0&id=6f84c4e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84c4e5",
  null
  
)

export default component.exports